export default __webpack_public_path__ + "f16efba717665a558c21a2d89e8801e9.jpg";